








import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Getter, State, Action } from "vuex-class";
import { User } from "@/types";
import logger from "@/configs/logger";
import * as api from "@/lib/api";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { objectify } from "@/helpers";

@Component({ components: { PulseLoader } })
export default class Callback extends Vue {
  @Prop({ required: true }) leadKey!: string;
  @Prop({ required: false }) beforeDisposition!: boolean;
  @Prop({ required: false }) alternatePhoneNumber!: boolean;
  @Action("bindTaskAttributes") bindTaskAttributes!: Function;
  @Action("changeCallMode") changeCallMode!: Function;
  @Action("setDisposition") setDisposition!: Function;
  @State("taskAttributes") taskAttributes!: any;
  @State("user") user!: User;
  @State("inCallMode") inCallMode!: boolean;
  @State("callConnected") callConnected!: boolean;

  dialog: boolean = false;
  hasError: boolean = false;
  dialStatus: string = "";
  toast: any = null;

  @Watch("inCallMode")
  onCallModeChange(val: any, preVal: any) {
    if (!val && preVal) {
      this.toast.goAway();
    }
  }

  @Watch("taskAttributes")
  onTaskAttributesUpdate(val: any, prev: any) {
    if (!Object.is(val, prev)) {
      // Use controlled local state for dial status
      const status = objectify(this.taskAttributes).outbound_dialing_status;
      if (status && status !== this.dialStatus) {
        this.dialStatus = status;
        this.toast = this.$toasted.info(status);
        if (
          !["queued", "initiated", "ringing", "in-progress"].includes(status)
        ) {
          this.toast.goAway(3000);
        }
      }
    }
  }

  @Watch("callConnected")
  onCallConnectedUpdate(val: boolean, prev: boolean) {
    if (val) this.dialog = false;
  }

  async handleCallback() {
    try {
      if (!this.leadKey) {
        throw new Error("Lead key required for callback.");
      }

      if (this.inCallMode && !this.beforeDisposition) {
        throw new Error("Cannot callback when ready in a call.");
      }

      if (this.beforeDisposition) {
        await this.setDisposition({
          disposition: "Call Back",
          disposition_note: "",
          isCallback: true
        });
      }

      this.hasError = false;
      this.dialStatus = "";
      this.dialog = true;

      const { data } = await api.callBack(
        this.leadKey,
        this.alternatePhoneNumber
      );
      const taskId = data.task_attribute_key.split("/")[1];

      this.bindTaskAttributes(taskId);
      this.changeCallMode(true);
    } catch (err) {
      this.hasError = true;
      logger("error", "call back error", err);
      if (objectify(err.response).data) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("Call back failed");
      }
    }
  }
}
